module.exports = __webpack_public_path__ + "img/torsten.99fe3074.gif";